'use strict';

module.exports = {
    NO_APPLE_PAY_BRAINTREE_CONFIGURATIONS: 'No Apple Pay Braintree Configurations',
    FRAUD_DATA_CELLECTION_ISNOT_ENABLED: 'Fraud Data collection isn\t enabled via Custom Site Preference'
};
